/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Json_Input_LabelInputs */

const en_json_input_label = /** @type {(inputs: Json_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Input`)
};

const ko_json_input_label = /** @type {(inputs: Json_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 입력`)
};

const ja_json_input_label = /** @type {(inputs: Json_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON入力`)
};

/**
* | output |
* | --- |
* | "JSON Input" |
*
* @param {Json_Input_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const json_input_label = /** @type {((inputs?: Json_Input_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Json_Input_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_json_input_label(inputs)
	if (locale === "ko") return ko_json_input_label(inputs)
	return ja_json_input_label(inputs)
});